import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation resources
import enTranslations from '../shared/locales/en/translation.json';
// eslint-disable-next-line import/no-named-as-default-member
i18next.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslations,
    },
  },
  lng: 'en', // default language
  fallbackLng: 'en', // fallback language if translation is missing
  debug: process.env.REACT_APP_ENVIRONMENT !== 'prod',
  interpolation: {
    escapeValue: false,
  },
});

export default i18next;
